import { Component, OnDestroy, OnInit } from "@angular/core";
import { BehaviorSubject, combineLatest, Observable, Subject } from "rxjs";
import { filter, first, map, mergeMap, takeUntil } from "rxjs/operators";
import { MirRule } from "src/app/models/mir-rule.model";
import { DefaultDivisionService } from "src/app/services/default-division.service";
import { RulesService } from "src/app/services/rules/rules.service";
import { ZonesService } from "src/app/services/zones.service";
import { isDefined } from "src/utils/isDefined/isDefined";

@Component({
	selector: "app-get-started",
	templateUrl: "./get-started.component.html",
	styleUrls: ["./get-started.component.scss"],
})
export class GetStartedComponent implements OnInit, OnDestroy {
	constructor(
		private defaultDivSvc: DefaultDivisionService,
		public zoneService: ZonesService,
		private ruleSvc: RulesService,
	) {}

	rule: MirRule = null;

	private checkDivIdSet$ = new BehaviorSubject(true);

	private destroy$ = new Subject();

	defaultDivId: string = null;
	currentDivisionId: string = null;
	originalDivisionId: string = null;
	_tempDefaultDivId: string = null;

	ngOnInit(): void {
		combineLatest([
			this.defaultDivSvc.getDefaultDivision().pipe(filter(isDefined), first()),
			this.ruleSvc.ruleToPatch$.pipe(filter(isDefined), first()),
		])
			.pipe(first())
			.subscribe(([division, rule]) => {
				this.rule = rule;
				this._tempDefaultDivId = division.divisionId;
				this.currentDivisionId = division.divisionId;
				this.originalDivisionId = division.divisionId;
				this.ruleSvc.storePatchedRule(this._tempDefaultDivId, this.rule);

				this.checkDivIdSet$.next(true);
			});

		this.checkDivIdSet$
			.pipe(
				mergeMap(_ => {
					return this.zoneService.divisionId$.pipe(first());
				}),
				takeUntil(this.destroy$),
			)
			.subscribe(divId => {
				if (divId) {
					// div Id already set because either it is a zone rule that we can derive id, or it's a legacy location user who we also derived the id from, so they have default selections on the div filter
					return;
				}
				if (this.rule) {
					this.defaultDivId = this._tempDefaultDivId;
					this.ruleSvc.storePatchedRule(this.defaultDivId, this.rule);
				}
			});
	}

	ngOnDestroy(): void {
		this.checkDivIdSet$.complete();
		this.destroy$.next();
		this.destroy$.complete();
	}

	showFilter$(): Observable<boolean> {
		return this.zoneService.hasOneDivision$.pipe(
			map(res => {
				return typeof res === "boolean";
			}),
		);
	}
}
